/**
 * The shared line-style model — the ONE canonical list of selectable line
 * styles (value + display label), in display order. Every line-style picker
 * reads this: the LineStyleSelect dropdown and the LineStyleDialog popup, so the
 * options never drift. Dash-pattern previews come from `svgDasharrayFromName`
 * (keyed by the same value).
 */
import type { LineStyleName } from "@/state/slices/uiSlice";

export const LINE_STYLE_OPTIONS: { value: LineStyleName; label: string }[] = [
  { value: "solid", label: "Solid" },
  { value: "dotted", label: "Dotted" },
  { value: "dashed", label: "Dashed" },
  { value: "largeDashed", label: "Large dashed" },
  { value: "sparseDotted", label: "Sparse dotted" },
];
